<ul>
  <li *ngFor="let repos of filteredList; let i = index" [class.active]="i === selected" class="repos" (click)="changeValue(repos)">{{repos.name}}</li>
</ul>
